import * as v from 'valibot';
import { Base64Schema, SaltSchema, TimestampSchema, UsernameSchema } from './common';
// =============================================================================
// Auth Schemas
// =============================================================================
export const ReserveUsernameSchema = v.object({
    username: UsernameSchema,
    turnstile_token: v.optional(v.string()),
});
export const ReserveUsernameResponseSchema = v.object({
    success: v.literal(true),
    expires_at: TimestampSchema, // ISO String or number
});
export const CheckUsernameResponseSchema = v.object({
    available: v.boolean(),
});
export const AuthChallengeSchema = v.object({
    identity_id: v.string(), // username
});
export const AuthChallengeResponseSchema = v.object({
    nonce: v.string(),
    salt: v.string(),
    kdf_params: v.string(),
    expires_at: TimestampSchema, // ISO String or number
});
export const AuthProveSchema = v.object({
    identity_id: v.string(),
    nonce: v.string(),
    signature: v.string(), // Hex string
});
export const AuthProveResponseSchema = v.object({
    success: v.literal(true),
    state: v.string(),
    subscriptionExpiresAt: v.nullable(TimestampSchema), // ISO String or number
});
export const RegisterSchema = v.object({
    identity_id: UsernameSchema,
    // Recovery (Master) Key Material
    km_recovery_wrap: Base64Schema,
    recovery_salt: SaltSchema,
    recovery_kdf_params: v.string(),
    // Public Keys
    recovery_public_key: v.string(), // Ed25519 PubKey
    mail_public_key: v.string(), // X25519 PubKey
});
export const RegisterResponseSchema = v.object({
    success: v.literal(true),
    expires_at: TimestampSchema, // ISO String or number
});
export const LogoutSchema = v.object({});
export const LogoutResponseSchema = v.object({
    success: v.literal(true),
});
export const SessionObjectSchema = v.object({
    session_id: v.string(),
    created_at: TimestampSchema,
    last_used_at: v.nullable(TimestampSchema),
    revoked_at: v.nullable(TimestampSchema),
    type: v.string(),
});
export const SessionListResponseSchema = v.object({
    sessions: v.array(SessionObjectSchema),
});
export const AccountExportResponseSchema = v.object({
    username: v.string(),
    created_at: TimestampSchema,
});
//# sourceMappingURL=auth.js.map